// Country and city data for onboarding
import indianCities from './indianCities.json';

export interface CountryData {
  name: string;
  cities: string[];
}

export const COUNTRIES_WITH_CITIES: CountryData[] = [
  {
    name: 'India',
    cities: indianCities,
  },
  {
    name: 'United States',
    cities: [
      'New York',
      'Los Angeles',
      'San Francisco',
      'Chicago',
      'Boston',
      'Seattle',
      'Austin',
      'Washington DC',
      'Miami',
      'Atlanta',
      'Houston',
      'Dallas',
      'San Diego',
      'Denver',
      'Phoenix',
      'Portland',
      'Philadelphia',
      'San Jose',
      'Detroit',
      'Minneapolis',
      'Las Vegas',
      'Orlando',
      'Nashville',
      'Charlotte',
      'Raleigh',
      'Other',
    ],
  },
  {
    name: 'United Kingdom',
    cities: [
      'London',
      'Manchester',
      'Birmingham',
      'Edinburgh',
      'Glasgow',
      'Liverpool',
      'Bristol',
      'Leeds',
      'Cardiff',
      'Newcastle',
      'Sheffield',
      'Nottingham',
      'Southampton',
      'Brighton',
      'Oxford',
      'Cambridge',
      'Belfast',
      'Aberdeen',
      'Reading',
      'Other',
    ],
  },
  {
    name: 'United Arab Emirates',
    cities: [
      'Dubai',
      'Abu Dhabi',
      'Sharjah',
      'Ajman',
      'Ras Al Khaimah',
      'Fujairah',
      'Umm Al Quwain',
      'Al Ain',
      'Other',
    ],
  },
  {
    name: 'Singapore',
    cities: [
      'Central Singapore',
      'Marina Bay',
      'Orchard',
      'Jurong',
      'Woodlands',
      'Tampines',
      'Bedok',
      'Queenstown',
      'Other',
    ],
  },
  {
    name: 'Canada',
    cities: [
      'Toronto',
      'Vancouver',
      'Montreal',
      'Calgary',
      'Ottawa',
      'Edmonton',
      'Winnipeg',
      'Quebec City',
      'Hamilton',
      'Kitchener',
      'Victoria',
      'Halifax',
      'Mississauga',
      'Brampton',
      'Surrey',
      'Other',
    ],
  },
  {
    name: 'Australia',
    cities: [
      'Sydney',
      'Melbourne',
      'Brisbane',
      'Perth',
      'Adelaide',
      'Gold Coast',
      'Canberra',
      'Newcastle',
      'Wollongong',
      'Hobart',
      'Geelong',
      'Townsville',
      'Cairns',
      'Darwin',
      'Other',
    ],
  },
  {
    name: 'Germany',
    cities: [
      'Berlin',
      'Munich',
      'Frankfurt',
      'Hamburg',
      'Cologne',
      'Stuttgart',
      'Düsseldorf',
      'Dortmund',
      'Essen',
      'Leipzig',
      'Bremen',
      'Dresden',
      'Hanover',
      'Nuremberg',
      'Bonn',
      'Other',
    ],
  },
  {
    name: 'France',
    cities: [
      'Paris',
      'Lyon',
      'Marseille',
      'Toulouse',
      'Nice',
      'Nantes',
      'Strasbourg',
      'Montpellier',
      'Bordeaux',
      'Lille',
      'Rennes',
      'Reims',
      'Saint-Étienne',
      'Toulon',
      'Grenoble',
      'Other',
    ],
  },
  {
    name: 'Netherlands',
    cities: [
      'Amsterdam',
      'Rotterdam',
      'The Hague',
      'Utrecht',
      'Eindhoven',
      'Tilburg',
      'Groningen',
      'Almere',
      'Breda',
      'Nijmegen',
      'Other',
    ],
  },
  {
    name: 'Switzerland',
    cities: [
      'Zurich',
      'Geneva',
      'Basel',
      'Bern',
      'Lausanne',
      'Lucerne',
      'St. Gallen',
      'Lugano',
      'Winterthur',
      'Other',
    ],
  },
  {
    name: 'Japan',
    cities: [
      'Tokyo',
      'Osaka',
      'Kyoto',
      'Yokohama',
      'Nagoya',
      'Sapporo',
      'Fukuoka',
      'Kobe',
      'Kawasaki',
      'Hiroshima',
      'Other',
    ],
  },
  {
    name: 'China',
    cities: [
      'Beijing',
      'Shanghai',
      'Shenzhen',
      'Guangzhou',
      'Chengdu',
      'Hangzhou',
      'Wuhan',
      'Xi\'an',
      'Suzhou',
      'Nanjing',
      'Hong Kong',
      'Other',
    ],
  },
  {
    name: 'South Korea',
    cities: [
      'Seoul',
      'Busan',
      'Incheon',
      'Daegu',
      'Daejeon',
      'Gwangju',
      'Suwon',
      'Ulsan',
      'Jeju',
      'Other',
    ],
  },
  {
    name: 'Brazil',
    cities: [
      'São Paulo',
      'Rio de Janeiro',
      'Brasília',
      'Salvador',
      'Fortaleza',
      'Belo Horizonte',
      'Manaus',
      'Curitiba',
      'Recife',
      'Porto Alegre',
      'Other',
    ],
  },
  {
    name: 'Other',
    cities: ['Other'],
  },
];

// Helper function to get cities for a country
export const getCitiesForCountry = (countryName: string): string[] => {
  const country = COUNTRIES_WITH_CITIES.find(c => c.name === countryName);
  return country ? country.cities : ['Other'];
};

// Get list of all countries
export const getCountries = (): string[] => {
  return COUNTRIES_WITH_CITIES.map(c => c.name);
};
